module.exports = __webpack_public_path__ + "img/shuffle (2).404de031.svg";